export const preferredLanguage = 'preferred_language';
